import React from 'react'

const useDialog = () => {
    const [openDialog, setOpenDialog] = React.useState(false)
    const [openDialogOk, setOpenDialogOk] = React.useState(false)
    const [openDialogConfirm, setOpenDialogConfirm] = React.useState(false)

    const handleOpen = () => {
        setOpenDialog(true)
    }

    const handleClose = () => {
        setOpenDialog(false)
    }

    const handleOpenOk = () => {
        setOpenDialogOk(true)
    }

    const handleOk = () => {
        setOpenDialogOk(false)
    }

    const handleOpenConfirm = () => {
        setOpenDialogConfirm(true)
    }

    const handleConfirm = () => {
        setOpenDialogConfirm(false)
    }

    const handleCancel = () => {
        setOpenDialogConfirm(false)
    }

    return {
        openDialog,
        onOpen: handleOpen,
        onClose: handleClose,
        openDialogOk,
        onOpenOk: handleOpenOk,
        onOk: handleOk,
        openDialogConfirm,
        onOpenConfirm: handleOpenConfirm,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
    }
}

export default useDialog
